export default theme => ({
  container: {
    display: 'flex',
    '& > *': {
      flex: '1 1 0',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  textContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3),
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(),
    },
  },
  title: {
    paddingBottom: theme.spacing(1),
  },
  subtitle: {
    marginBottom: theme.spacing(3),
    lineHeight: 0.8,
    [theme.breakpoints.down('md')]: {
      lineHeight: 1,
    },
  },
  playerWrapper: {
    position: 'relative',
    paddingTop: '56.25%',
  },
  player: {
    position: 'absolute',
    top: 0,
    left: 0,
    alignSelf: 'stretch',
    backgroundColor: theme.palette.grey.main,
    '& svg': {
      height: 120,
      width: 120,
    },
  },
  playIcon: {
    zIndex: 5,
    width: 100,
    height: 100,
    '& .icon-fill': {
      fill: theme.palette.common.white,
    },
    '& .icon-stroke': {
      stroke: theme.palette.common.white,
    },
  },
});
